<template>
  <div class="action">
    <img alt="Vue logo" class="logo" src="./assets/logo.gif" />
    <div class="social_icon">
      <a href="https://twitter.com/pop_headz" target="_blank">
        <img class="social" src="./assets/twitter.png" />
      </a>
      <a href="https://www.instagram.com/popheadzofficial/" target="_blank">
        <img class="social" src="./assets/ins.png" />
      </a>
      <a href="https://discord.gg/dY6DYTRMQd" target="_blank">
        <img class="social" src="./assets/discord.png" />
      </a>
    </div>
  </div>
</template>

<style>
.action {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  height: 100vh;
  align-items: center;
  margin: auto;
  text-align: center;
  align-self: center;
  justify-content: center;
}

.logo {
  justify-content: center;
  width: 80%;
  object-fit: cover;
  align-items: center;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.social_icon {
  display: flex;
  flex-direction: row;
  width: 90%;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  align-self: center;
}
.social {
  width: 40px;
  object-fit: cover;
  filter: invert(1) !important;
}

@media screen and (max-width: 640px) {
  .social_icon {
    justify-content: center;
    align-items: center;
    align-self: center;
  }
}

@media screen and (max-width: 640px) {
  .social {
    width: 20px;
  }
}
</style>
